// ** Initial State
const initialState = {
  data: [],
  total: 1,
  from: 0,
  to: 0,
  params: {},
  selectedData: null
}

const createInformation = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DATA_CREATE_INFORMATION':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params,
        from: action.from,
        to: action.to,
      }
    case 'GET_CREATE_INFORMATION':
      return { ...state, selectedData: action.selectedData }
    case 'ADD_CREATE_INFORMATION':
      return { ...state }
    case 'EDIT_CREATE_INFORMATION':
      return { ...state }
    case 'DELETE_CREATE_INFORMATION':
      return { ...state }
    default:
      return { ...state }
  }
}
export default createInformation
